import React, { useEffect, useState } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

import Base from '../../../utils/base'

export default function RoomInfo1(props) {
  var base = new Base()
  const {t, i18n} = useTranslation()
  const momentNow = moment()

  const [numGuests, setNumGuests] = useState(1)
  const [checkInDate, setCheckInDate] = useState(null)
  const [checkOutDate, setCheckOutDate] = useState(null)

  useEffect(() => {
    var lang = window.localStorage.getItem('lang')
		i18n.changeLanguage(lang != null ? lang : 'en')

    setTimeout(() => {
      window.$('#checkin').datetimepicker({
        format: 'DD/MM/YYYY',
        allowInputToggle: true,
        minDate: moment(),
      })

      window.$('#checkout').datetimepicker({
        format: 'DD/MM/YYYY',
        allowInputToggle: true,
        minDate: moment(),
      })

      window.$('#checkin').on('change.datetimepicker', function(e) {
        setCheckInDate(moment(e.date))
      })
      window.$('#checkout').on('change.datetimepicker', function(e) {
        setCheckOutDate(moment(e.date))
      })

      
    }, 1000)
  }, [])

  useEffect(() => {
    if(checkInDate != null)
      reinit()
  }, [checkInDate])

  function reinit(){
    window.$('#checkout').datetimepicker('destroy')

    window.$('#checkout').datetimepicker({
      format: 'DD/MM/YYYY',
      allowInputToggle: true,
      minDate: checkInDate,
    })

    window.$('#checkout').on('change.datetimepicker', function(e) {
      setCheckOutDate(moment(e.date))
    })
  }

  function decreaseGuest(){
    if(numGuests > 1)
      setNumGuests(numGuests - 1)
  }

  function increaseGuest(){
    setNumGuests(numGuests + 1)
  }

  function onSearchClicked(){
    window.open(`https://www.e1-booking.com/widget?id=zoom-hotels-jemursari&room_id=&checkin=${checkInDate.format('DD-MM-YYYY')}&checkout=${checkOutDate.format('DD-MM-YYYY')}`, '_blank')
  }

  return (
    <div className="room-details">
      <div className="container">
        <div className="row gutter-y-30">
          <div className="col-lg-8">
            <div className="room-details__item wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='300ms'>
              <div className="room-details__room-info">
                <div className="room-details__room-info__top">
                  <div className="room-details__room-info__left">
                    <h2 className="room-details__room-info__title" style={{ fontSize: '1.875rem', }}>{base.capitalizeFirstLetter(props.roomInfo.title)}</h2>
                    <p className="room-details__room-info__form" style={{ fontSize: '1rem', }}>{t('from')} <span style={{ fontSize: '1.875rem', }}>Rp. {props.roomInfo.price.toLocaleString(base.locale_string)}</span> {t('per_night')}</p>
                  </div>
                  <p className="room-details__room-info__rating"><i className="icon-star1"></i> {props.roomInfo.average_rating.toLocaleString(base.locale_string)}</p>
                </div>
                
                {/* <div className="room-details__room-info__bottom">
                  <div className="room-details__room-info__bottom__left">
                    <div className="room-details__room-info__bottom__item">
                      <div className="room-details__room-info__bottom__icon">
                        <i className="icon-audience"></i>
                      </div>
                      <div className="room-details__room-info__bottom__content">
                        <h5 className="room-details__room-info__bottom__title">8 Person</h5>
                        <span className="room-details__room-info__bottom__subtitle">Guests</span>
                      </div>
                    </div>
                    <div className="room-details__room-info__bottom__item">
                      <div className="room-details__room-info__bottom__icon">
                        <i className="icon-clock"></i>
                      </div>
                      <div className="room-details__room-info__bottom__content">
                        <h5 className="room-details__room-info__bottom__title">3 days</h5>
                        <span className="room-details__room-info__bottom__subtitle">Duration</span>
                      </div>
                    </div>
                    <div className="room-details__room-info__bottom__item">
                      <div className="room-details__room-info__bottom__icon">
                        <i className="icon-selection"></i>
                      </div>
                      <div className="room-details__room-info__bottom__content">
                        <h5 className="room-details__room-info__bottom__title">460</h5>
                        <span className="room-details__room-info__bottom__subtitle">Guests</span>
                      </div>
                    </div>
                  </div>
                  <div className="room-details__room-info__bottom__right">
                    <a href="javascript:void(0)" className="room-details__room-info__bottom__right__item"><i className="icon-Heart"></i></a>
                    <a href="javascript:void(0)" className="room-details__room-info__bottom__right__item"><i className="icon-share"></i></a>
                  </div>
                </div> */}
              </div>
            </div>

            <div className="room-details__item wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='300ms'>
              <div className="room-details__info">
                <h3 className="room-details__title" style={{ fontSize: '1.875rem', }}>{t('overview')}</h3>
                <p className="room-details__text" style={{ fontSize: '1rem', }}>{props.roomInfo.overview}</p>
              </div>
            </div>

            <div className="room-details__item wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='300ms'>
              <div className="room-details__amenities">
                <h3 className="room-details__title" style={{ fontSize: '1.875rem', }}>{t('facility')}</h3>
                <ul className="room-details__amenities__list list-unstyled">
                  {
                    props.roomInfo.arr_show_facility.map((facility, index) => (
                      <li className="room-details__amenities__item" style={{ fontSize: '1rem', }}>
                        <i className="icon-mark"></i>{facility.name}
                      </li>
                    ))
                  }
                </ul>
              </div>
            </div>
          </div>
          
          <div className="col-lg-4">
            <div className="room-details__sidebar">
              <div className="room-details__sidebar__item room-details__sidebar__item--three wow fadeInUp" data-wow-duration='1500ms' data-wow-delay='300ms'>
                <div className="room-details__sidebar__form">
                  <div className="room-details__sidebar__top">
                    <div className="room-details__sidebar__top__item">
                      <h4 className="room-details__sidebar__top__title" style={{ fontSize: '1.2rem', }}>{t('book_room')}</h4>
                    </div>
                  </div>
                  <div className="room-details__sidebar__content">
                    <form className="room-details__sidebar__form__inner contact-form-validated" novalidate="novalidate">
                      <div className="room-details__sidebar__control">
                        <label for="checkin" style={{ fontSize: '1rem', }}>{t('check_in')}:</label>
                        <input className="datetimepicker-input" id="checkin" type="text" value={(checkInDate != null ? checkInDate : momentNow).format('DD/MM/YYYY')} data-toggle="datetimepicker" data-target="#checkin" style={{ fontSize: '1rem', }}/>
                        <i className="icon-calendar-6"></i>
                      </div>
                      <div className="room-details__sidebar__control">
                        <label for="checkout" style={{ fontSize: '1rem', }}>{t('check_out')}:</label>
                        <input className="datetimepicker-input" id="checkout" type="text" value={(checkOutDate != null ? checkOutDate : momentNow).format('DD/MM/YYYY')} data-toggle="datetimepicker" data-target="#checkout" style={{ fontSize: '1rem', }}/>
                        <i className="icon-calendar-6"></i>
                      </div>
                      {/* <div className="room-details__sidebar__control">
                        <label for="guests">{t('guest')}</label>
                        <select name="guests" className="form-control" value={numGuests} onChange={(e) => setNumGuests(e.target.value)} id="guests">
                          <option value="1">1</option>
                          <option value="2">2</option>
                          <option value="3">3</option>
                          <option value="4">4</option>
                          <option value="5">5</option>
                        </select>
                      </div> */}
                      {/* <div className="room-details__sidebar__total">Total:<span>$160.00</span></div> */}
                      <button type="button" onClick={() => onSearchClicked()} className="solinom-btn solinom-btn--base mt-5" style={{ fontSize: '1rem', }}>{t('roomIndex.bookNow')}</button>
                    </form>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
